var _rect, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#FFCD00",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#FFCD00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "copyIconTitle"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    x: 8,
    y: 7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "16 3 4 3 4 17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5efe46244dd4d8544dabcff921bc1f3a.svg";
export { ForwardRef as ReactComponent };